import { render, staticRenderFns } from "./m-orm-select-with-popular-dialog.vue?vue&type=template&id=72f27f18&scoped=true&lang=pug&"
import script from "./m-orm-select-with-popular-dialog.vue?vue&type=script&lang=js&"
export * from "./m-orm-select-with-popular-dialog.vue?vue&type=script&lang=js&"
import style0 from "./m-orm-select-with-popular-dialog.vue?vue&type=style&index=0&id=72f27f18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f27f18",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCol,VDataTable})
